import axiosInstance from "../AxiosInstance";
import { ABOUT, ADDEDUCATION, APPOINTMENTSREFERAL, CASEREFERAL, DASHBOARDS_PEAK, DASHBOARDS_STATS, FAQ, FILEUPLAOD, LEGAL, PRIVACYPOLICY, PROMOTION, RESOURCES, SEARCH, SERVICE, SUBADMIN, TERMSCONDITIONS } from "./adminEndpoints";

export function postServices(payload) {
  return axiosInstance.post(SERVICE, payload);
}
export function getServices(limit, page, search) {
  let url = `${SERVICE}`;
  const params = [];

  if (limit && limit !== "") {
    params.push(`limit=${encodeURIComponent(limit)}`);
  }

  if (page && page !== "") {
    params.push(`page=${encodeURIComponent(page)}`);
  }

  if (search && search.trim() !== "") {
    params.push(`search=${encodeURIComponent(search.trim())}`);
  }

  if (params.length > 0) {
    url += `?${params.join("&")}`;
  }

  return axiosInstance.get(url);
}


export function deleteServices(id) {
  return axiosInstance.delete(`${SERVICE}?serviceId=${id}`);
}

export function editServices(payload) {
  return axiosInstance.put(SERVICE, payload);
}

export function getFaQs(page, limit,search) {
 



    let url = `${FAQ}?page=${page}&limit=${limit}`;
 
     
  if (search && search.trim() !== "") {
    url += `&search=${encodeURIComponent(search)}`;
  }
  return axiosInstance.get(url);
 

}

export function deleteFaQs(id) {
  return axiosInstance.delete(`${FAQ}?faqId=${id}`);
}

export function editFAQ(payload) {
  return axiosInstance.put(FAQ, payload);
}

export function addFAQ(payload) {
  return axiosInstance.post(FAQ, payload);
}

export function getInfo() {
  return axiosInstance.get(LEGAL);
}

export function createInfo(payload) {
  return axiosInstance.post(LEGAL, payload);
}

export function getLegalInfo() {
  return axiosInstance.get(LEGAL);
}

export function getLegalInfoDetails(legalInfoId) {
  return axiosInstance.get(`${LEGAL}/details`, {
    params: { legalInfoId },
  });
}

export function addLegalFaq(payload) {
  return axiosInstance.post(`${LEGAL}/faq`, payload);
}

export function updateLegalFaq(payload) {
  return axiosInstance.put(`${LEGAL}/faq`, payload);
}

export function deleteLegalFaq(faqId, legalInfoId) {
  const params = new URLSearchParams({ faqId });
  if (legalInfoId) params.set("legalInfoId", legalInfoId);
  return axiosInstance.delete(`${LEGAL}/faq?${params.toString()}`);
}

export function updateFullLegalInfo(payload) {
  return axiosInstance.put(LEGAL, payload);
}

export function getResources() {
  return axiosInstance.get(RESOURCES);
}

export function createResources(payload) {
  return axiosInstance.post(RESOURCES, payload);
}

export function addFile(payload) {
  return axiosInstance.post(FILEUPLAOD, payload);
}




export function addEducation(payload) {
  return axiosInstance.post(ADDEDUCATION, payload);
}
 

export function getEducation(page, limit,type, search) {
  let url = `${ADDEDUCATION}?page=${page}&limit=${limit}&type=${type}`;
  
  if (search && search.trim() !== "") {
    url += `&search=${encodeURIComponent(search)}`;
  }
  return axiosInstance.get(url);
}


export function deleteEducation(id) {
  return axiosInstance.delete(`${ADDEDUCATION}?educationId=${id}`);
}

export function updateEducation(payload) {
  return axiosInstance.put(ADDEDUCATION,payload);
}







export function getPrivayPolicy() {
  return axiosInstance.get(PRIVACYPOLICY);
 
}

export function createPrivayPolicy(payload) {
  return axiosInstance.post(PRIVACYPOLICY,payload);
 
}
export function deletePrivayPolicy(id) {
  return axiosInstance.delete(`${PRIVACYPOLICY}?privacyPolicyId=${id}`);
 
}

export function updatePrivayPolicy(payload) {
  return axiosInstance.put(PRIVACYPOLICY,payload)

} 








export function getTermsConditions() {
  return axiosInstance.get(TERMSCONDITIONS);
 
}

export function createTermsConditions(payload) {
  return axiosInstance.post(TERMSCONDITIONS,payload);
 
}
export function deleteTermsConditions(id) {
  return axiosInstance.delete(`${TERMSCONDITIONS}?termsConditionId=${id}`);
 
}

export function updateTermsConditions(payload) {
  return axiosInstance.put(TERMSCONDITIONS,payload)

} 






export function getAbout() {
  return axiosInstance.get(ABOUT);
 
}

export function createAbout(payload) {
  return axiosInstance.post(ABOUT,payload);
 
}
export function deleteAbout(id) {
  return axiosInstance.delete(`${ABOUT}?aboutId=${id}`);
 
}

export function updateAbout(payload) {
  return axiosInstance.put(ABOUT,payload)

}
   

 



export function getPromotion(page,limit,search) {
 



  let url = `${PROMOTION}?page=${page}&limit=${limit}`;
 
     
  if (search && search.trim() !== "") {
    url += `&search=${encodeURIComponent(search)}`;
  }
  return axiosInstance.get(url);

 
}

export function createPromotion(payload) {
  return axiosInstance.post(PROMOTION,payload);
 
}
export function deletePromotion(id) {
  return axiosInstance.delete(`${PROMOTION}?promotionId=${id}`);
 
}

export function updatePromotion(payload) {
  return axiosInstance.put(PROMOTION,payload)

} 







export function getSearch(page,limit,search) {

let url = `${SEARCH}?page=${page}&limit=${limit}`;
 
     
  if (search && search.trim() !== "") {
    url += `&search=${encodeURIComponent(search)}`;
  }
  return axiosInstance.get(url);
 
}

export function createSearch(payload) {
  return axiosInstance.post(SEARCH,payload);
 
}
export function deleteSearch(id) {
  return axiosInstance.delete(`${SEARCH}?id=${id}`);
 
}

export function updateSearch(payload) {
  return axiosInstance.put(SEARCH,payload)

} 







export function getReferal(page,limit,search) {

let url = `${CASEREFERAL}?page=${page}&limit=${limit}`;
 
     
  if (search && search.trim() !== "") {
    url += `&search=${encodeURIComponent(search)}`;
  }
  return axiosInstance.get(url);
 
}


export function getReferalDetail(id) {

let url = `admin/case-referral/details?id=${id}`;
 
     
 
  return axiosInstance.get(url);
 
}


export function updateReferalDetail(payload) {

let url = `${CASEREFERAL}/update-status`;
 
     
 
  return axiosInstance.put(url,payload);
 
}















export function getAppointments(page,limit,search,statusFilter,startDate,endDate,serviceDepartment) {

let url = `${APPOINTMENTSREFERAL}?page=${page}&limit=${limit}`;
 
     
  if (search && search.trim() !== "") {
    url += `&search=${encodeURIComponent(search)}`;
  }
  if (statusFilter) {
    url += `&status=${encodeURIComponent(statusFilter)}`;
  }

  if (startDate) {
    url += `&startDate=${encodeURIComponent(startDate)}`;
  }

  if (endDate) {
    url += `&endDate=${encodeURIComponent(endDate)}`;
  }
  

  if (serviceDepartment) {
    url += `&serviceDepartment=${encodeURIComponent(serviceDepartment)}`;
  }
  return axiosInstance.get(url);
 
}

export function getAppointmentsById(id) {

let url = `${APPOINTMENTSREFERAL}/details?appointmentId=${id}`;
 
     
  // if (search && search.trim() !== "") {
  //   url += `&search=${encodeURIComponent(search)}`;
  // }
  return axiosInstance.get(url);
 
}






export function updateAppointentStatus(paylaod) {

let url = `${APPOINTMENTSREFERAL}`;
 
     
  // if (search && search.trim() !== "") {
  //   url += `&search=${encodeURIComponent(search)}`;
  // }
  return axiosInstance.put(url,paylaod);
 
}








export function getSTATS(service, start, end) {
  let url = `${DASHBOARDS_STATS}`;
  const params = [];

  if (service) params.push(`serviceDepartment=${service}`);
  if (start) params.push(`startDate=${start}`);
  if (end) params.push(`endDate=${end}`);

  if (params.length > 0) {
    url += `?${params.join("&")}`;
  }

  return axiosInstance.get(url);
}

export function getPEAK(groupBy,start,end) {

 

let url = `${DASHBOARDS_PEAK}`;
  const params = [];

  if (groupBy) params.push(`groupBy=${groupBy}`);
  if (start) params.push(`startDate=${start}`);
  if (end) params.push(`endDate=${end}`);

  if (params.length > 0) {
    url += `?${params.join("&")}`;
  }

  return axiosInstance.get(url);
 
}





 



//getDepartments
export function getDepartments() {
  let url = `admin/department`;
  return axiosInstance.get(url);
}




//get SubAdmin
export function getSubAdmins(page,limit,search) {
  let url = `${SUBADMIN}/list?page=${page}&limit=${limit}`;
 
     
  if (search && search.trim() !== "") {
    url += `&search=${encodeURIComponent(search)}`;
  }
  return axiosInstance.get(url);
 
}
export function updateAdminStatus(payload) {
  let url = `${SUBADMIN}/toggle-status`;
  return axiosInstance.patch(url,payload);
}

export function createNewAdmin(payload) {
  let url = `${SUBADMIN}/create`;
  return axiosInstance.post(url,payload);
}
export function updateAdminInfo(id ,payload) {
  let url = `${SUBADMIN}/update/${id}`;
  return axiosInstance.put(url,payload);
} 

export function deleteAdmin(id) {
  let url = `${SUBADMIN}/delete?adminId=${id}`;
  return axiosInstance.delete(url);
}

export function updatePermission(payload) {
  let url = `${SUBADMIN}/update-permissions`;
  return axiosInstance.put(url,payload);
}






